/**
 * Verbessert Barrierefreiheit für JetEngine Radio-Buttons.
 */

function initJetEngineRadioFix() {
    // Add tabindex to JetEngine Form Elements
    const radioButtons = document.querySelectorAll(".jet-radio-list__item .jet-radio-list__button");

    radioButtons.forEach(radioButton => {
        radioButton.setAttribute("tabindex", "0");

        // Add event listener for keydown event
        radioButton.addEventListener("keydown", (event) => {
            // Check if the Enter key (key code 13) is pressed
            if (event.key === "Enter") {
                const inputElement = radioButton.closest(".jet-radio-list__item").querySelector("input[type='radio']");
                inputElement.checked = true;

                // Optionally trigger a change event if needed
                inputElement.dispatchEvent(new Event("change"));
            }
        });
    })
}

export { initJetEngineRadioFix };